import { create } from 'zustand'

import { applyTheme, readStoredTheme, storeTheme, type Theme } from '@/shared/lib/theme'

/**
 * =============================================================================
 * ESTADO DEL TEMA
 * =============================================================================
 * CLIENT STATE puro: la preferencia visual vive en el navegador de cada quien,
 * no en el backend. Por eso Zustand y no TanStack Query (ver docs/03).
 *
 * No usa el middleware `persist` a propósito: se guarda un string plano
 * ("light" | "dark" | "system") en la misma clave que lee el script inline de
 * `index.html`. `persist` envolvería el valor en `{state:{…},version:…}` y el
 * script tendría que saber ese formato.
 * =============================================================================
 */

interface ThemeState {
  /** Lo que el usuario eligió. El tema que se pinta se deriva en `theme.ts`. */
  theme: Theme
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeState>((set) => ({
  theme: readStoredTheme(),
  setTheme: (theme) => {
    storeTheme(theme)
    applyTheme(theme)
    set({ theme })
  },
}))

// El script inline ya dejó la clase correcta en el primer frame; esto la
// reafirma por si ese script se quitara y mantiene `color-scheme` en sync.
applyTheme(useThemeStore.getState().theme)
